import store from "@/store";

const appSnackbar = {
  setMessage(message) {
    store.commit("setAppSnackbar", message);
  }
};

export default appSnackbar;
